import request from '@/utils/axiosRequest.js'

// 消息服务
// 最新订单消息
export function resentOrderMessage(){
  return request({
    url: "/message/resentOrderMessage",
    method: "get",
    showLoading: false // 轮询请求，不显示全局Loading，解决闪烁问题
  })
}

// 确认收到消息
export function confirmReceiveOrderMessage(orderNo) {
  return request({
    url: "/message/confirmReceiveOrderMessage/"+ orderNo,
    method: "delete"
  })
}



// WEBPACK FOOTER //
// ./src/api/modules/app/messageApi.js